<ng-template #detailModal let-modal>
  <div class="modal-body p-0">
    <div class="d-flex flex-column detail-container">
      <div class="modal-header px-4 py-3 d-flex align-items-center border-bottom">
        <span class="modal-title" style="font-size: 24px; font-weight: 600;">Chi tiết voucher</span>
        <button class="btn btn-close btn-sm" [id]="'voucher_detail_modal_close_btn'" style="position: unset !important;"
          (click)="modal.dismiss('Cross click');">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <div class="voucher-detail-container">
        <div class="voucher-detail">
          <div class="voucher-discount">
            <span style="font-size: 12px; font-weight: 600; color: #444444; word-break: break-word;">#{{selectedVoucher.code}}</span>
            <ng-container *ngIf="selectedVoucher.discountType == discountType.Percentage">
              <span style="font-size: 14px; font-weight: 600; color: var(--theme-color); line-height: 100%;">
                Chiết khẩu
              </span>
              <span class="discount-value">{{selectedVoucher.discountValue}}%</span>
              <span *ngIf="selectedVoucher.maximumAmount"
                style="font-size: 14px; font-weight: 600; color: #000000; line-height: 100%;">
                tối đa {{selectedVoucher.maximumAmount | currencySymbol}}
              </span>
            </ng-container>
            <ng-container *ngIf="selectedVoucher.discountType == discountType.FixedAmount">
              <span style="font-size: 14px; font-weight: 600; color: var(--theme-color); line-height: 100%;">Giảm</span>
              <span class="discount-value">{{selectedVoucher.discountValue | currencySymbol}}</span>
            </ng-container>
            <ng-container *ngIf="selectedVoucher.discountType == discountType.Coin">
              <span style="font-size: 14px; font-weight: 600; color: var(--theme-color); line-height: 100%;">Hoàn</span>
              <span class="discount-value">{{selectedVoucher.discountValue | currencySymbol: false}} xu</span>
            </ng-container>
          </div>

          <div class="divider"></div>

          <div class="voucher-info">
            <div *ngIf="selectedVoucher.tags && selectedVoucher.tags.length" class="voucher-info-tag">
              <div class="voucher-tags">
                <div *ngFor="let tag of selectedVoucher.tags" class="tag">{{tag.name}}</div>
              </div>
            </div>
            <!-- <span class="voucher-title">{{selectedVoucher.titleVoucher}}</span> -->
            <div class="description">
              <div class="description-title">Điều kiện áp dụng:</div>
              <div class="voucher-description">{{selectedVoucher.descriptionVoucher}}</div>
            </div>
            <div class="description">
              <div class="description-title">Số lượng voucher:</div>
              <div class="voucher-description">{{selectedVoucher.remainingUses > 99 ? '99+' : selectedVoucher.remainingUses}}</div>
            </div>
            <div class="description">
              <div class="description-title">Số lượt dùng/ngày:</div>
              <div class="voucher-description">{{selectedVoucher.usesLimitPerDay > 99 ? '99+' : selectedVoucher.usesLimitPerDay}}</div>
            </div>
            <div class="description">
              <div class="description-title">Hạn sử dụng:</div>
              <div class="voucher-description">{{selectedVoucher.conditions?.end | date: 'dd/MM/yyyy'}}</div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoadingProducts || selectedVoucher?.applicableProducts"
        class="d-flex flex-column text-start bg-white applicable-products">
        <span class="text-start applicable-products-title">
          Danh sách sản phẩm áp dụng
        </span>

        <!-- Search bar -->
        <div class="search-wrapper" *ngIf="selectedVoucher">
          <div class="search-bar">
            <input type="text" class="search-input" placeholder="Bạn đang tìm sản phẩm nào?"
              [(ngModel)]="productSearchKeyword" (ngModelChange)="onSearchKeywordChange()" />
            <button class="search-btn" (click)="triggerSearch()">
              <i class="ri-search-line"></i>
            </button>
          </div>
        </div>

        <div class="row g-3 g-md-2 g-sm-2 g-xs-2 row-cols-2 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-xs-2">
          <div style="align-items: center" *ngFor="let product of selectedVoucher?.applicableProducts">
            <app-product-box-horizontal [product]="product" [isListView]="true"
              class="w-100"></app-product-box-horizontal>
            <!--        <div *ngIf="isLoadingProducts" class="position-absolute top-50 start-50 translate-middle" style="z-index: 1050;">-->
            <!--          <app-loader-->
            <!--            [loaderClass]="'loader-wrapper'"-->
            <!--            [loaderStyle]="{ width: '50px', height: '50px' }"-->
            <!--          ></app-loader>-->
            <!--        </div>-->
          </div>
        </div>
        <!-- Pagination -->
        <div style="margin-bottom: 10px;" *ngIf="!isLoadingProducts && paginate.totalItems > 0">
          <app-pagination [total]="paginate.totalItems" [currentPage]="paginate.currentPage"
            [pageSize]="paginate.pageSize" [paginateRange]="7" (setPage)="onPageChanged($event)">
          </app-pagination>
        </div>

        <div class="text-center w-100 mt-3"
          *ngIf="!isLoadingProducts && selectedVoucher?.applicableProducts?.length === 0">
          <p>Không tìm thấy sản phẩm.</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>